import { ISelectData } from 'components/atoms/SelectComponent';

import { EAdmissionConditionsEnums } from 'enums/akcionarKorpAkce/admissionConditionsEnums';

export const AdmissionConditionsSelect: ISelectData[] = [
    {
        labelcz: 'SRD_PRUVODCE_VH_D_PRIDAT_MASH',
        value: EAdmissionConditionsEnums.MASH
    },
    {
        labelcz: 'SRD_PRUVODCE_VH_D_PRIDAT_MAPO',
        value: EAdmissionConditionsEnums.MAPO
    },
    {
        labelcz: 'SRD_PRUVODCE_VH_D_PRIDAT_MAAL',
        value: EAdmissionConditionsEnums.MAAL
    },
    {
        labelcz: 'SRD_PRUVODCE_VH_D_PRIDAT_MALR',
        value: EAdmissionConditionsEnums.MALR
    },
    {
        labelcz: 'SRD_PRUVODCE_VH_D_PRIDAT_MAHI',
        value: EAdmissionConditionsEnums.MAHI
    },
    {
        labelcz: 'SRD_PRUVODCE_VH_D_PRIDAT_MATK',
        value: EAdmissionConditionsEnums.MATK
    },
    {
        labelcz: 'SRD_PRUVODCE_VH_D_PRIDAT_MANP',
        value: EAdmissionConditionsEnums.MANP
    }
];
